// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Tab = require("@mui/material/Tab").default;
var Tabs = require("@mui/material/Tabs").default;
var Expln_React_Column = require("@expln/utils/src/main/Expln_React_Column.bs.js");
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var IconButton = require("@mui/material/IconButton").default;
var Clear = require("@mui/icons-material/Clear").default;

function getNextId(st) {
  return [
          {
            nextId: st.nextId + 1 | 0,
            tabs: st.tabs,
            activeTabId: st.activeTabId
          },
          String(st.nextId)
        ];
}

function getTabs(st) {
  return st.tabs;
}

function addTab(st, label, closable, data) {
  var match = getNextId(st);
  var newId = match[1];
  var st$1 = match[0];
  var newTabs = st$1.tabs.concat([{
          id: newId,
          label: label,
          closable: closable,
          data: data
        }]);
  return [
          {
            nextId: st$1.nextId,
            tabs: newTabs,
            activeTabId: newTabs.length === 1 ? newId : st$1.activeTabId
          },
          newId
        ];
}

function openTab(st, tabId) {
  if (st.tabs.some(function (t) {
          return t.id === tabId;
        })) {
    return {
            nextId: st.nextId,
            tabs: st.tabs,
            activeTabId: tabId
          };
  } else {
    return st;
  }
}

function removeTab(st, tabId) {
  var newTabs = st.tabs.filter(function (t) {
        return t.id !== tabId;
      });
  return {
          nextId: st.nextId,
          tabs: newTabs,
          activeTabId: newTabs.length === 0 ? "" : (
              st.activeTabId === tabId ? Caml_array.get(newTabs, 0).id : st.activeTabId
            )
        };
}

function useTabs(param) {
  var match = React.useState(function () {
        return {
                nextId: 0,
                tabs: [],
                activeTabId: ""
              };
      });
  var setState = match[1];
  var state = match[0];
  var addTab$1 = function (label, closable, data) {
    return Expln_utils_promise.promise(function (rlv) {
                Curry._1(setState, (function (prev) {
                        var match = addTab(prev, label, closable, data);
                        Curry._1(rlv, match[1]);
                        return match[0];
                      }));
              });
  };
  var openTab$1 = function (id) {
    Curry._1(setState, (function (prev) {
            return openTab(prev, id);
          }));
  };
  var removeTab$1 = function (id) {
    Curry._1(setState, (function (prev) {
            return removeTab(prev, id);
          }));
  };
  var renderTabs = function (param) {
    var tabs = state.tabs;
    if (tabs.length === 0) {
      return null;
    }
    var activeTabId = state.activeTabId;
    return React.createElement(Expln_React_Column.make, {
                children: React.createElement(Tabs, {
                      value: activeTabId,
                      onChange: (function (param, id) {
                          Curry._1(setState, (function (prev) {
                                  return openTab(prev, id);
                                }));
                        }),
                      variant: "scrollable",
                      children: tabs.map(function (tab) {
                            return React.createElement(Tab, {
                                        value: tab.id,
                                        label: tab.closable ? React.createElement("span", undefined, tab.label, React.createElement(IconButton, {
                                                    onClick: (function (evt) {
                                                        evt.stopPropagation();
                                                        var id = tab.id;
                                                        Curry._1(setState, (function (prev) {
                                                                return removeTab(prev, id);
                                                              }));
                                                      }),
                                                    component: "div",
                                                    children: React.createElement(Clear, {})
                                                  })) : tab.label,
                                        key: tab.id
                                      });
                          }),
                      key: activeTabId
                    })
              });
  };
  return {
          addTab: addTab$1,
          openTab: openTab$1,
          removeTab: removeTab$1,
          tabs: state.tabs.slice(),
          activeTabId: state.activeTabId,
          renderTabs: renderTabs,
          updateTabs: Curry.__1(setState)
        };
}

exports.getTabs = getTabs;
exports.addTab = addTab;
exports.openTab = openTab;
exports.removeTab = removeTab;
exports.useTabs = useTabs;
/* react Not a pure module */
